import { observable, decorate, action } from 'mobx';
import * as ErrorsUtils from '../utils/ErrorsUtils';
import services from '../utils/ServiceUtils';
import * as Endpoints from '../utils/Endpoints';

const OFERTA_ACEPTADA = 2;
class OfertasStore {
  productosAProtar = {
    creditos: [],
    tarjetas: [],
    lineas: [],
    cuentas: [],
    productosSinOferta: [],
  };
  solicitud = {};
  oferta = {};

  conIcp;
  idChallenge;
  popupErrorSinacofi = {
    show: false,
  };

  constructor(appstore) {
    this.appstore = appstore;
  }

  fail = (err) => {
    this.appstore.hideLoading();
    if (err.response) {
      const response = err.response;
      if (response.status) {
        if (response.status === 401) {
          ErrorsUtils.showSessionInvalida();
        } else {
          ErrorsUtils.showErrorFor(-99999);
        }
      } else {
        ErrorsUtils.showErrorFor(-99999);
      }
    } else {
      ErrorsUtils.showErrorFor(-99999);
    }
  };

  generarPdf = (tipoOferta, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Generando documento');
    }, 500);
    services
      .get(Endpoints.OFERTAS_ENDPOINT + '/' + this.solicitud.id + '/' + tipoOferta + '/pdf')
      .then(
        action('generarPdfOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            onResult(response.data.pdf);
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  obtenerProductosAPortar = (onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Listando los productos a portar');
    }, 500);
    services
      .get(Endpoints.SOLICITUD_ENDPOINT + '/' + this.solicitud.id + '/productos/portar')
      .then(
        action('obtenerPreguntasOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          let productosPortar = {};
          const data = response.data;
          let lineas;
          let tarjetas;
          if (data.cuentas && data.cuentas.length > 0) {
            productosPortar.cuentas = data.cuentas.map((item) => {
              return {
                tipoProducto: item.tipoProducto,
                nombreProducto: item.nombreProducto,
                numeroOperacion: item.numeroOperacion,
                selected: true,
              };
            });
          }

          if (data.rotativos && data.rotativos.length > 0) {
            tarjetas = data.rotativos.filter((item) => {
              return item.tipoProducto === 'TARCRE';
            });
            lineas = data.rotativos.filter((item) => {
              return item.tipoProducto === 'LINCRE';
            });
            if (tarjetas && tarjetas.length > 0) {
              productosPortar.tarjetas = tarjetas;
              productosPortar.tarjetasSelected = true;
            }
            if (lineas && lineas.length > 0) {
              productosPortar.lineas = lineas;
              productosPortar.lineasSelected = true;
            }
          }
          if (data.creditos && data.creditos.length > 0) {
            productosPortar.creditos = data.creditos;
            productosPortar.creditosSelected = true;
          }
          productosPortar.productosSinOferta = data.productosSinOferta;
          this.productosAProtar = productosPortar;
          if (onResult) {
            onResult(productosPortar);
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  buildNuevaOfertaTarjeta = (ofertaTarjeta) => {
    let result;
    if (ofertaTarjeta && ofertaTarjeta.selected) {
      result = ofertaTarjeta;
    }
    return result;
  };

  buildNuevaOfertaCuenta = (ofertaCuenta) => {
    let result;
    if (ofertaCuenta && ofertaCuenta.selected) {
      const cuentasSeleccionadas = this.productosAProtar.cuentas.filter((item) => {
        return item.selected;
      });
      if (cuentasSeleccionadas && cuentasSeleccionadas.length > 0) {
        const cuentasReemplaza = ofertaCuenta.productosReemplaza.filter((item) => {
          const index = cuentasSeleccionadas.findIndex((cuenta) => {
            return cuenta.numeroOperacion === item.numeroOperacion;
          });
          return index > -1;
        });
        result = {
          nombreProducto: ofertaCuenta.nombreProducto,
          tipoCuenta: ofertaCuenta.tipoOferta,
          costoMantencionAnual: ofertaCuenta.costoMantencionAnual,
          montoSegurosObligatorios: ofertaCuenta.montoSegurosObligatorios,
          montoSegurosVoluntarios: ofertaCuenta.montoSegurosVoluntarios,
          diferenciaCostosTotales: ofertaCuenta.diferenciaCostosTotales,
          asociarLineaCredito: ofertaCuenta.asociarLineaCredito,
          totalLinea: ofertaCuenta.totalLinea,
          totalDeudaLinea: ofertaCuenta.totalDeudaLinea,
          costoPagarDeudaLinea: ofertaCuenta.costoPagarDeudaLinea,
          observaciones: ofertaCuenta.observaciones,
          productosReemplaza: cuentasReemplaza,
        };
      }
    }
    return result;
  };

  buildNuevaOfertaCredito = (ofertaCredito) => {
    let result;
    if (ofertaCredito && ofertaCredito.selected) {
      result = ofertaCredito;
    }
    return result;
  };

  buildOfertaAcepta = (oferta) => {
    const nuevaOfertaTarjeta = this.buildNuevaOfertaTarjeta(oferta.ofertaTarjeta);
    const nuevaOfertaCuenta = this.buildNuevaOfertaCuenta(oferta.ofertaCuenta);
    const nuevaOfertaCredito = this.buildNuevaOfertaCredito(oferta.ofertaCredito);
    //nueva oferta
    return {
      solicitudId: this.cabeceraOferta.solicitudId,
      clienteId: this.cabeceraOferta.clienteId,
      estadoOferta: OFERTA_ACEPTADA,
      nombreCliente: this.cabeceraOferta.nombreCliente,
      rutCliente: this.cabeceraOferta.rutCliente,
      fechaEmision: this.cabeceraOferta.fechaEmision,
      fechaVigencia: this.cabeceraOferta.fechaVigencia,
      proveedorInicial: this.cabeceraOferta.proveedorInicial,
      proveedorFinal: this.cabeceraOferta.proveedorInicial,
      canalContacto: this.cabeceraOferta.canalContacto,
      descripcionOferta: this.cabeceraOferta.descripcionOferta,
      ofertas: [
        {
          tituloOferta: oferta.tituloOferta,
          resultadoPortabilidad: oferta.resultadoPortabilidad,
          compromisoNoRetracto: oferta.compromisoNoRetracto,
          tipoOferta: oferta.tipoOferta,
          ofertaTarjeta: nuevaOfertaTarjeta,
          ofertaCredito: nuevaOfertaCredito,
          ofertaCuenta: nuevaOfertaCuenta,
          observaciones: oferta.observaciones,
        },
      ],
    };
  };

  obtenerOferta = (credito, tarjeta, cuenta, rotativo, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('calculando tu oferta');
    }, 500);
    services
      .get(Endpoints.OFERTAS_ENDPOINT + '/' + this.solicitud.id + '?credito=' + credito + '&tarjeta=' + tarjeta + '&cuenta=' + cuenta + '&rotativo=' + rotativo)
      .then(
        action('obtenerOfertasOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          this.cabeceraOferta = response.data;
          this.oferta = response.data.ofertas[0];
          if (this.oferta.ofertaCredito) {
            this.oferta.ofertaCredito.selected = true;
          }
          if (this.oferta.ofertaTarjeta) {
            this.oferta.ofertaTarjeta.selected = true;
          }
          if (this.oferta.ofertaCuenta) {
            this.oferta.ofertaCuenta.selected = true;
          }
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  guardarOfertaAceptada = (tipoOferta, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('guardando oferta aceptada');
    }, 500);
    services
      .post(Endpoints.OFERTAS_ENDPOINT + '/' + this.cabeceraOferta.solicitudId + '/aceptar', { tipoOfertaAceptada: tipoOferta })
      .then(
        action('guardarOfertaOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  compromisoNoRetracto = (compromiso, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Actualizando tu seleccion');
    }, 500);
    services
      .post(Endpoints.OFERTAS_ENDPOINT + '/' + this.solicitud.id + '/compromiso', {
        compromiso: compromiso,
      })
      .then(
        action('compromisoNoRetractoOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('compromisoNoRetractoFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  cargarOfertaAceptada = (onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('calculando tu oferta');
    }, 500);
    services
      .get(Endpoints.OFERTAS_ENDPOINT + '/' + this.solicitud.id + '/aceptada')
      .then(
        action('obtenerOfertasOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          this.cabeceraOferta = response.data;
          this.oferta = response.data.ofertas[0];
          if (this.oferta.ofertaCredito != null && this.oferta.ofertaCredito) {
            this.oferta.ofertaCredito.selected = true;
          }
          if (this.oferta.ofertaTarjeta != null && this.oferta.ofertaTarjeta) {
            this.oferta.ofertaTarjeta.selected = true;
          }
          if (this.oferta.ofertaCuenta != null && this.oferta.ofertaCuenta) {
            this.oferta.ofertaCuenta.selected = true;
          }
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  generarPdfOferta = (idSolicitud, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Generando documento');
    }, 500);
    services
      .get(Endpoints.OFERTAS_ENDPOINT + '/' + idSolicitud + '/pdf')
      .then(
        action('generarPdfOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            onResult(response.data.pdf);
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  generarPdfOfertaAceptada = (idSolicitud, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Generando documento');
    }, 500);
    services
      .get(Endpoints.OFERTAS_ENDPOINT + '/' + idSolicitud + '/pdf/aceptada')
      .then(
        action('generarPdfOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            onResult(response.data.pdf);
          }
        })
      )
      .catch(
        action('obtenerPreguntasFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };

  ejecutarRetracto = (retractoCredito, retractoTarjeta, retractoCuenta, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Actualizando tus productos');
    }, 500);
    services
      .post(Endpoints.OFERTAS_ENDPOINT + '/' + this.solicitud.id + '/retracto', {
        retractoCredito: retractoCredito,
        retractoTarjeta: retractoTarjeta,
        retractoCuenta: retractoCuenta,
      })
      .then(
        action('retractoOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            onResult(response.data.pdf);
          }
        })
      )
      .catch(
        action('retractoFail', (err) => {
          clearTimeout(timer);
          this.fail(err);
          if (onFail) {
            onFail();
          }
        })
      );
  };
}

decorate(OfertasStore, {
  productosAPortar: observable,
  solicitud: observable,
  obtenerProductosAPortar: action,
  oferta: observable,
});
export default OfertasStore;
